/**
 * Locale API
 *
 * Persists the authenticated user's preferred locale to the backend.
 * The backend stores it on the User document so emails are sent in
 * the correct language and the preference is restored on next login
 * regardless of device.
 */

import { apiClient } from '@/shared/lib/api-client';

/**
 * Save the user's locale preference to the backend.
 * No-op if the call fails (UI preference is already applied locally).
 */
export async function updateUserLocale(locale: string): Promise<void> {
  try {
    await apiClient.patch<{ locale: string }>('/auth/locale', { locale });
  } catch {
    // Silently ignore — the local preference is already applied
  }
}

/**
 * Fetch the list of supported locales from the backend.
 * Falls back to an empty array on error.
 */
export async function getAvailableLocales(): Promise<string[]> {
  try {
    const data = await apiClient.get<{ locales: string[] }>(
      '/translation/locales'
    );
    return data.locales ?? [];
  } catch {
    return [];
  }
}
